import type { CounterPaymentProps } from '@agos/shared'

import { PaymentDialog } from './PaymentDialog'

/**
 * The till's *Zaplatiť* as *Rozvoz - nástenka* opens it on *Vydaná* - `FRONTEND.md` §9.740, owner O111.
 *
 * The owner asked for *"the same dialog as Otvorené stoly"*, so it **is** that dialog: Hotovosť / Karta – terminál,
 * the Kasa picker, *Zaplatiť všetko* printing the receipt and asking whether the payment went through, the close
 * through `split-payment` - with the one difference they named: *"assign it to someone, who use Vydaná button"*.
 * `closer="whoever-closes"` asks nobody and sends no `employeeId`, and the server credits the signed-in person
 * (`BACKEND.md` §10A.386).
 *
 * **The board cannot import this** - §5, modules never import each other - so the shell hands it over through
 * `CounterPaymentProvider`. A discount edited inside it refreshes the board the way a payment does; closing it is
 * the board's own `onClose`.
 */
export function CounterPaymentDialog({ order, onClose, onPaid }: CounterPaymentProps) {
  return (
    <PaymentDialog
      order={order}
      closer="whoever-closes"
      onClose={onClose}
      onPaid={onPaid}
      onOrderChanged={onPaid}
    />
  )
}
